import $ from 'jquery';
import Mustache from 'mustache';

window.addEventListener('load', function() {

  var $map = $('#map');
  if($map.length <= 0)
    return;

  var mapGoogle;
  var currentDealers = [];
  var currentMarkersById = [];
  var currentMarkers = [];
  var currentInfowindows = {};
  var searchedPlace;
  var currentPositionLat = 46;
  var currentPositionLng = 2.352222;
  var currentDealerType = 'all';
  // var show_distance = false;
  var markerCluster;
  var dealers_list_item_template;
  var dealer_infowindow_template;
  var dataToRender = {};
  var dataRendered = '';
  var dataToRender_labels;
  var dataToRender_univers;
  var dealerTypes;
  var current_dealer_id;
  var bounds;
  var currentZoom = 6;
  var timer = null;

  initMap();
  function initMap() {

    // Load Map
    mapGoogle = new google.maps.Map(document.getElementById('map'), {
      zoom: currentZoom,
      minZoom: 5,
      maxZoom: 14,
      center: new google.maps.LatLng(currentPositionLat, currentPositionLng),
      scrollwheel: true,
      zoomControl: true,
      draggable: true,
      mapTypeId: 'roadmap', // roadmap, satellite, terrain, hybrid
      // gestureHandling: 'greedy'
    });

    google.maps.event.addListener(mapGoogle, 'bounds_changed', function() {
      // console.log("bounds_changed");
      bounds = mapGoogle.getBounds();
    });

    // Reload Dealers after Map Move (Zoom or Drag&Drop)
    mapGoogle.addListener('dragend', function() {
      // console.log('dragend');
      if (timer)
        clearTimeout(timer);
      timer = setTimeout(loadDealers, 500);
    });
    mapGoogle.addListener('zoom_changed', function() {
      // console.log('zoom_changed');
      if (timer)
        clearTimeout(timer);
      timer = setTimeout(loadDealers, 500);
    });

    // Create & apply Map Style
    var styledMapType = new google.maps.StyledMapType(
      [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dadada"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#c9c9c9"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        }
      ]
    );
    mapGoogle.mapTypes.set('styled_map', styledMapType);
    mapGoogle.setMapTypeId('styled_map');

    // Autocomplete
    var search = document.getElementById('js-dealers_search');

    // On Autocomplete enter, auto select first choice
    (function pacSelectFirst(input){
      var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

      if (input.addEventListener)
        input.addEventListener = addEventListenerWrapper;
      else if (input.attachEvent)
        input.attachEvent = addEventListenerWrapper;

      function addEventListenerWrapper(type, listener) {

        if (type == "keydown") {
          var orig_listener = listener;
          listener = function (event) {
            var suggestion_selected = $(".pac-item-selected").length > 0;
            if (event.which == 13 && !suggestion_selected) {
              var simulated_downarrow = $.Event("keydown", {keyCode:40, which:40})
              orig_listener.apply(input, [simulated_downarrow]);
            }
            orig_listener.apply(input, [event]);
          };
        }

        // add the modified listener
        _addEventListener.apply(input, [type, listener]);
      }
    })(search);
    // Init Autocomplete field - allowing only City searches
    var autocomplete = new google.maps.places.Autocomplete(search, {
      types: ['(regions)']
    });
    // Bind the map's bounds (viewport) property to the autocomplete object,
    // so that the autocomplete requests use the current map bounds for the
    // bounds option in the request.
    autocomplete.bindTo('bounds', mapGoogle);
    // Set the data fields to return when the user selects a place.
    autocomplete.setFields(['address_components', 'geometry', 'name']);
    // Events when User enter a place
    autocomplete.addListener('place_changed', function() {
      searchedPlace = autocomplete.getPlace();

      // console.log(searchedPlace);
      // console.log(searchedPlace.geometry.location.lat());

      // Move to Search Place
      mapGoogle.panTo(new google.maps.LatLng(
        searchedPlace.geometry.location.lat(),
        searchedPlace.geometry.location.lng()
      ));
      // Set recommended zoom - Country vs Street
      mapGoogle.fitBounds(searchedPlace.geometry.viewport);

      // Load Dealers after Pan finished
      setTimeout(loadDealers, 1500);

    });

    // User Location Popup Request
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function(userPosition){
        currentPositionLat = userPosition.coords.latitude;
        currentPositionLng = userPosition.coords.longitude;

        // Set Map center
        mapGoogle.panTo(new google.maps.LatLng(currentPositionLat, currentPositionLng));
        mapGoogle.setZoom(currentZoom+1);
      });
    } else{
      mapGoogle.setZoom(currentZoom+1);
    }

    // Load Dealers on Init
    setTimeout(loadDealers, 1000);

  }

  // Events when Dealer category changes
  $('.js-radios input[type=radio]').change(function() {

    // Set current Dealer Type
    currentDealerType = this.value;

    loadDealers();
  });

  /**
   * Load Dealers on List & Map & Move Map according to results
   */
  function loadDealers(type = currentDealerType, viewport = null){

    // console.log("loadDealers");

    $.ajax({
      type: 'GET',
      url: "/wp-json/f-one/dealers",
      data: {
        type: type,
        boundLatMin: bounds ? bounds.getSouthWest().lat() : null,
        boundLatMax: bounds ? bounds.getNorthEast().lat() : null,
        boundLngMin: bounds ? bounds.getSouthWest().lng() : null,
        boundLngMax: bounds ? bounds.getNorthEast().lng() : null,
      },
      success: function(data) {
        console.log(data);
        currentDealers = data.dealers;
        // console.log("data.dealers");
        // console.log(currentDealers);
        $(".sellers__list__content").empty();
        addDealersOnMap();
        addDealersInList(data);
      }
    });
  }

  /**
   * Add Dealers on Map & Auto Center Map
   */
  function addDealersOnMap() {
    // console.log("addDealersOnMap");

    // Create all Dealers Markers & InfoWindows
    createMarkersAndInfowindows();

    // Add Marker Clusters
    createMarkerClusters();

    // Open current Infowindow
    if(current_dealer_id && currentMarkersById && currentMarkersById[current_dealer_id])
      currentInfowindows[current_dealer_id].open(mapGoogle, currentMarkersById[current_dealer_id]);

  }

  /**
   * Re-Create all Dealers Markers & InfoWindows
   */
  function createMarkersAndInfowindows(){

    currentInfowindows = [];
    currentMarkersById = [];
    currentMarkers     = [];

    dealer_infowindow_template = $('#dealer_infowindow').html();
    Mustache.parse(dealer_infowindow_template);
    dataToRender = {};

    $.each(currentDealers, function (key, dealer){

      var latitude = parseFloat(dealer.lat);
      var longitude = parseFloat(dealer.lng);
      var myLatLng = new google.maps.LatLng(latitude, longitude);
      var dealerIcon = {};
      var markerHeight = 38.9513108614;

      // Create marker
      // If Distributor and Other(s), keep Other(s) only (one bicolor is possible)
      dealerTypes = [];
      if (dealer.types){
        dealer.types.forEach(type => {
          if( ! (type.slug == 'distributor' && dealer.types.length > 1))
            dealerTypes.push(type);
        });
      }
      if(dealerTypes.length == 2){
        dealerIcon = {
          anchor: new google.maps.Point(markerHeight * 0.334, markerHeight),
          size: new google.maps.Size(markerHeight * 0.7, markerHeight * 1.1),
          url: '/app/themes/f-one/dist/img/maps-bicolore.svg'
        };
      } else{
        dealerIcon = {
          path: "M0,-40c-7.312,0 -13.33,6.012 -13.338,13.324c0,12.008 13.338,26.676 13.338,26.676c0,0 13.338,-14.668 13.338,-26.676c-0.008,-7.312 -6.026,-13.324 -13.338,-13.324Zm0,18.67c0,0 0,0 0,0c-2.925,0 -5.332,-2.407 -5.332,-5.332c0,-0.005 0,-0.009 0,-0.014c0,-2.925 2.407,-5.332 5.332,-5.332c2.925,0 5.332,2.407 5.332,5.332c0,0.005 0,0.009 0,0.014c0,2.925 -2.407,5.332 -5.332,5.332c0,0 0,0 0,0Z",
          fillColor: dealerTypes[0] ? dealerTypes[0].color : "#000",
          fillOpacity: 1,
          strokeWeight: 0,
          size: new google.maps.Size(markerHeight * 0.668, markerHeight),
          anchor: new google.maps.Point(0,0)
        };
      }

      var marker = new google.maps.Marker({
        id: dealer.ID,
        map: mapGoogle,
        position: myLatLng,
        icon: dealerIcon,
      });
      currentMarkersById[dealer['ID']] = marker;
      currentMarkers.push(marker);

      // Store Data & Create Marker InfoWindow
      dataToRender.id = dealer.ID;
      dataToRender.title = dealer.post_title;
      dataToRender.address = dealer.address.split("<br />");
      // if(show_distance)
      //   dataToRender.distance = dealer.distance;
      dataToRender.telephone = dealer.telephone;
      dataToRender.email = dealer.mail;
      dataToRender.website = dealer.website;
      dataToRender.direction = "http://maps.google.com/maps?q=" + encodeURIComponent(dealer.post_title +" "+dealer.address);
      dataToRender.hasBicolor = false;
      dataToRender.types = [];
      if (dealer.types){
        dealer.types.forEach(type => {
          if( ! (type.slug == 'distributor' && dealer.types.length > 1))
            dataToRender.types.push(type);
        });
        dataToRender.type_color = dataToRender.types[0].color;
        dataToRender.hasBicolor = dataToRender.types.length > 1 ? true : false;
      }
      dataToRender.univers = dataToRender_univers = [];
      if(dealer.univers){
        $.each(dealer.univers, function (key, univers) {
          dataToRender_univers[key] = univers;
        });
        dataToRender.univers = dataToRender_univers;
      }
      var infowindow = new google.maps.InfoWindow({
        content: Mustache.render(dealer_infowindow_template, dataToRender)
      });
      currentInfowindows[dealer['ID']] = infowindow;

      // Open Infowindow when Click on Marker
      google.maps.event.addListener(marker, 'click', function () {

        // Set current Dealer Id
        current_dealer_id = dealer['ID'];

        // Close all IW and open current one
        $.each(currentInfowindows, function (key,value) {
          if (currentInfowindows[key])
            currentInfowindows[key].close();
        });
        infowindow.open(mapGoogle, marker);

        // Set active item in List
        $('.seller--is-selected').removeClass('seller--is-selected');
        $('.js-dealer#'+current_dealer_id).addClass('seller--is-selected');
      });
    });

  }

  /**
   * Create Marker Clusters
   */
  function createMarkerClusters(){
    if (markerCluster)
      markerCluster.clearMarkers();
    markerCluster = new MarkerClusterer(
      mapGoogle,
      currentMarkers,
      {
        maxZoom: 12,
        imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
      }
    );
  }


  /**
   * Add Dealers in List // To Do with Mustache
   */
  function addDealersInList(data){

    // Get Dealers list item Template
    dealers_list_item_template = $('#dealers_list_item').html();
    Mustache.parse(dealers_list_item_template);
    dataToRender = {};
    dataRendered = ''; // data.dealers.length

    // Get Dealers Data and Render on Template
    $.each(data.dealers, function (key, dealer) {
      dataToRender.id = dealer.ID;
      dataToRender.title = dealer.post_title;
      dataToRender.address = dealer.address.split("<br />");
      // if(show_distance)
      //   dataToRender.distance = dealer.distance;
      dataToRender.types = [];
      if (dealer.types){
        dealer.types.forEach(type => {
          if( ! (type.slug == 'distributor' && dealer.types.length > 1))
            dataToRender.types.push(type);
        });
        dataToRender.type_color = dealer.types[0].color;
        dataToRender.hasBicolor = dataToRender.types.length > 1 ? true : false;
      }
      dataToRender.labels = dataToRender_labels = [];
      if(dealer.labels){
        $.each(dealer.labels, function (key, label) {
          dataToRender_labels[key] = label.url;
        });
        dataToRender.labels = dataToRender_labels;
      }
      dataRendered += Mustache.render(dealers_list_item_template, dataToRender);

    });
    if(dataRendered)
      $('.sellers__list__content').html(dataRendered);

    // On click on list item, open related infowindow
    $(".sellers__list__content .js-dealer").click(function() {

      // console.log("on_list_item_click");
      current_dealer_id = $(this).attr('id');

      // Move & Zoom to current Dealer on Map
      mapGoogle.panTo(currentMarkersById[current_dealer_id].position);
      smoothZoom(mapGoogle, 14, mapGoogle.getZoom());

      // Display current Dealer Infowindow on Map
      $.each(currentInfowindows, function (key,value) {
        if (currentInfowindows[key])
          currentInfowindows[key].close();
      });
      currentInfowindows[current_dealer_id].open(mapGoogle, currentMarkersById[current_dealer_id]);

      // Set List item active class (just before beeing removed)
      $('.seller--is-selected').removeClass('seller--is-selected');
      $('.seller.js-dealer[id="'+current_dealer_id+'"]').addClass('seller--is-selected');

    });

    // Set List item active class (after beeing removed)
    $('.seller--is-selected').removeClass('seller--is-selected');
    if(current_dealer_id)
      $('.seller.js-dealer[id="'+current_dealer_id+'"]').addClass('seller--is-selected');
  }

  /**
   * Smooth zoom
   */
  function smoothZoom (mapGoogle, max, cnt) {

    if (cnt >= max)
      return;

    var z = google.maps.event.addListener(mapGoogle, 'zoom_changed', function(event){
      google.maps.event.removeListener(z);
      smoothZoom(mapGoogle, max, cnt + 1);
    });
    setTimeout(function(){mapGoogle.setZoom(cnt)}, 80);
  }

});
